import React from 'react'
import { customFilter } from 'react-bootstrap-table2-filter'
import HeaderSearchBar from './HeaderSearchBar'

export let numberFilter;
let internalNameFilter;
let externalNameFilter;
let classInternalName;
let classExternalName;

export function clearFilter() {
  internalNameFilter?.(null)
  numberFilter?.(null)
  externalNameFilter?.(null)
  classInternalName?.(null)
  classExternalName?.(null)
}

export const columns = [
  {
    dataField: 'checkBox',
    text: '',
    headerClasses: 'checkBox-header-cell',
    classes: 'checkBox-cell'
  },
  {
    dataField: 'number',
    text: 'articleAdmin:articleNumber',
    sort: true,
    filterKey: 'filter.number',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { numberFilter = filter }} />
  },
  {
    dataField: 'internalName',
    text: 'articleAdmin:articleNameIntern',
    sort: true,
    filterKey: 'filter.internalName',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { internalNameFilter = filter }} />
  },
  {
    dataField: 'externalName',
    text: 'articleAdmin:articleNameExtern',
    sort: true,
    filterKey: 'filter.externalName',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { externalNameFilter = filter }} />
  },
  {
    dataField: 'class.internalName',
    text: 'articleAdmin:articleClassNameIntern',
    sort: true,
    filterKey: 'filter.classInternalName',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { classInternalName = filter }} />
  },
  {
    dataField: 'class.externalName',
    text: 'articleAdmin:articleClassNameExtern',
    sort: true,
    filterKey: 'filter.classExternalName',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { classExternalName = filter }} />
  },
  {
    dataField: 'actions',
    text: '',
    headerClasses: 'actions-header-cell',
    classes: 'actions-cell'
  }
];
